var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/correct-prototype-getter.js
// module id = 175
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35